import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { Subject } from 'rxjs';
import { ActionButton } from '../../../models/app/action-button';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css']
})

export class SettingsComponent implements OnInit, OnDestroy {

    @HostBinding("class.component-flex-vertical-fill") addClass = true;

    private destroy = new Subject<void>();

    public constructor(private appService: AppService) {

        // setup actions
        let actionButtons: ActionButton[] = [];

        actionButtons.push(new ActionButton("APP FEED", "", "", ""));

        this.appService.setActionsDataSource(actionButtons);
    }

    public ngOnInit(): void { }

    public ngOnDestroy() {

        this.appService.setActionsDataSource([]);
        this.destroy.next();
        this.destroy.complete();
    }
}
